<template>
  <div>
    <div
      class="text-h5 text-md-h4"
      :class="{
        'd-flex justify-start justify-md-center': center,
        'pb-2': !wave
      }"
    >
      <strong>
        <slot></slot>
      </strong>
    </div>
    <wave :center="center" class="py-4" v-if="wave" />
  </div>
</template>

<script>
import Wave from "@/components/Wave";
export default {
  name: "MainTitle",
  components: { Wave },
  props: {
    wave: {
      type: Boolean,
      default() {
        return false;
      }
    },
    center: {
      type: Boolean,
      default() {
        return false;
      }
    }
  }
};
</script>
